import StudentDashboardStudentAssignmentsPage from "./page"

export default StudentDashboardStudentAssignmentsPage
